import React from 'react';
import { Box, Typography, Card, CardContent, Grid } from '@mui/material';
import { TrendingUp as TrendingUpIcon, Assessment as AssessmentIcon, Category as CategoryIcon } from '@mui/icons-material';
import { useReporting } from '../ReportingContext';
import MockChart from '../MockChart';
import MockPieChart from '../MockPieChart';

const CategoryStatsTab = () => {
  const {
    categoryData,
  } = useReporting();

  return (
  <Box>
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <CategoryIcon color="primary" />
              <Box>
                <Typography variant="h4">28</Typography>
                <Typography variant="body2" color="text.secondary">Total Categories</Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <TrendingUpIcon color="success" />
              <Box>
                <Typography variant="h4">24</Typography>
                <Typography variant="body2" color="text.secondary">Active Categories</Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <AssessmentIcon color="info" />
              <Box>
                <Typography variant="h4">156</Typography>
                <Typography variant="body2" color="text.secondary">Total Offers</Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <TrendingUpIcon color="warning" />
              <Box>
                <Typography variant="h4">5.6</Typography>
                <Typography variant="body2" color="text.secondary">Avg Offers/Category</Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>

    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <MockChart title="Category Performance" type="bar" />
      </Grid>
      <Grid item xs={12} md={4}>
        <MockPieChart title="Category Distribution" data={categoryData} />
      </Grid>
    </Grid>
  </Box>

  );
};

export default CategoryStatsTab;
